module.exports = "<div class=\"tab\" [class.active]=\"tabActive\">{{ tabName | translate }}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/subproduct_tab.component.html
// module id = 565
// module chunks = 1